import React, { FC, useContext } from 'react';
import { ImageDataLike } from 'gatsby-plugin-image';
import { Card } from '../card';
import { CardFeed } from '../cardFeed/CardFeed';
import { SectionContext } from '../../context/SectionContext';

// Interface

export interface FeedProps {
  items: ItemProps[];
}

export interface ItemProps {
  tag: string;
  heading?: string;
  url: string;
  metaTitle: string;
  metaDetail: string;
  image?: ImageDataLike | string;
  id: string;
  label: string;
}

// JSX

export const Feed: FC<FeedProps> = ({ items, ...rest }) => {
  const { sectionBackground } = useContext(SectionContext);

  if (!items || items.length <= 0) {
    return null;
  }

  return (
    <CardFeed {...rest}>
      {items?.length >= 1 &&
        items.map(
          ({ id, url, label, metaTitle, metaDetail, heading, image, tag }) => (
            <Card
              tag={tag}
              heading={heading}
              metaTitle={metaTitle}
              metaDetail={metaDetail}
              image={image}
              url={url}
              label={label}
              key={id}
              background={
                sectionBackground === 'neutralWhite' ? 'brandLight' : 'white'
              }
            />
          )
        )}
    </CardFeed>
  );
};

export default Feed;
